import React, {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import HorizontalStepperSecondary from '../../components/Stepper/HorizontalStepperSecondary'
import UsuarioCC from './Components/1UsuarioCC'
import InformacionCC from './Components/2InformacionCC'
import EmpresaCC from './Components/3EmpresaCC'
import ContactoCC from './Components/4ContactoCC'
// import MetodoConfirmacionCC from './Components/5MetodoConfirmacionCC'
import DesignExterno from '../../components/DesignExterno/DesignExterno'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {
  creacionUsuarioChangePage,
  creacionUsuarioClear,
} from '../../actions/creacion-usuario/creacionUsuario.actions'
import {getTiposDocumento} from '../../actions/catalogos.actions'
import {KEYS} from '../../constants/keysStorage'

const titles = ['Empresa', 'Información', 'Usuario', 'Contacto']

const CrearCuentaIndex = () => {
  const history = useHistory()
  const paginaActual: number = useSelector((state: State) => state.creacionUsuario.paginaActual)
  const verifyEstatus = localStorage.getItem(KEYS.FLAG_VERIFY_VIEW);
  const dispatch = useDispatch()

  useEffect(() => {
    if (verifyEstatus !== "true") {
      dispatch(creacionUsuarioClear());
    }
    
    dispatch(getTiposDocumento());
    localStorage.removeItem(KEYS.USERNAME_CLIENTE);
    return () => {
      const verifyEstatus = localStorage.getItem(KEYS.FLAG_VERIFY_VIEW);
      if (verifyEstatus !== "true") {
        dispatch(creacionUsuarioClear());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaActual])

  const next = () => dispatch(creacionUsuarioChangePage(+1))
  const prev = () => {
    if (paginaActual <= 0) return history.push('/')
    if (paginaActual > 0) dispatch(creacionUsuarioChangePage(-1))
  }

  return (
    <DesignExterno title={<span> Crea tu cuenta</span>}>
      <section className='centrar-horizontal' style={{width: '40%'}}>
        <div className='w-form form-content'>
          <button onClick={prev} className='back-button w-inline-block'></button>
          {paginaActual < 4 && (
            <>
              <h2 className='h2-titles xl'>
                Regístrate&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </h2>
              <div className='m'>Ingresa los siguientes datos.</div>
              <div className='form-separator'></div>
              <div style={{transform: 'scale(0.85)'}}>
                <HorizontalStepperSecondary titles={titles} paginaActiva={paginaActual} />
              </div>
              {paginaActual === 0 && <EmpresaCC next={next} />}
              {paginaActual === 1 && <InformacionCC next={next} prev={prev} />}
              {paginaActual === 2 && <UsuarioCC next={next} prev={prev} />}
              {paginaActual === 3 && <ContactoCC next={next} prev={prev} />}
            </>
          )}
          {/* {current === 4 && <MetodoConfirmacionCC next={next} prev={prev} />} */}
        </div>
      </section>
    </DesignExterno>
  )
}

export default CrearCuentaIndex
